import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  text-align: center;
  border: 1px solid #cbcaca;
  z-index: 1;
  width: 100%;
  background: linear-gradient(0deg, #f2f4f4 21.6%, #d2d2d2 97.25%);
  border-radius: 0.35rem;
`;

const Text = styled.div(({ theme }) => {
  const { type } = theme;

  return `
    padding: 1px 0;
    position: relative;
    color: rgba(0, 0, 0, 0.6);
    font-size: ${type.size.tiny};
    font-family: ${type.face};
    font-weight: ${type.weight.black};
    line-height: ${type.size.regular};
    z-index: 3;
  `;
});

const Progress = styled.div<{ percentage: number }>(({ percentage }) => {
  let fill;

  if (percentage >= 0 && percentage <= 100) {
    fill = percentage;
  }

  if (percentage < 0) {
    fill = 0;
  }

  if (percentage > 100) {
    fill = 100;
  }

  return `
    position: absolute;
    top: 0;
    left: 0;
    background-image: 
      url("data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 23'%3E%3Cpath opacity='.2' d='M4.2 23h-4l4-23h4l-4 23Z' fill='%23fff'/%3E%3C/svg%3E"),
      linear-gradient(90deg, #FF8000 0%, #FFBC48 99.98%);
    width: ${fill}%;
    height: 100%;
    z-index: 2;
    border-radius: 0.35rem;
  `;
});

export interface IProgressBar {
  percentage: number;
  display?: string;
  className?: string;
}

const ProgressBar: FC<IProgressBar> = ({ percentage, display, className }) => {
  const text = display || `${percentage}%`;

  const classString = className ? className : '';

  return (
    <Container className={classString}>
      <Progress percentage={percentage} />
      <Text>{text}</Text>
    </Container>
  );
};

export default ProgressBar;
